export default "__VITE_ASSET__Bo$gL4JZ__"